import React, {lazy} from 'react';

/**
 * Export all react components you intend to use in your site.
 */

export const CalendarWidget = lazy(() => import("./components/CalendarWidget"));
export const SocialIcons = lazy(() => import("./components/SocialIcons"));
export const StoryClip = lazy(() => import("./components/StoryClip"));
export const JobsWidget = lazy(() => import("./components/JobsWidget"));
export const RelatedContentWidget = lazy(() => import("./components/RelatedContentWidget"));
export const TheDailyNav = lazy(() => import('./components/TheDailyNav'));
export const TheDailySingleSidebar = lazy(() => import('./components/TheDailySingleSidebar'));

